<div class="acs-page">
  <!-- Page Header -->
  <div class="acs-page-header">
    <div class="acs-page-header__title-section">
      <h1 class="acs-page-header__title">
        📢 Manage Announcements
      </h1>
      <p class="acs-page-header__subtitle">
        View and manage your announcements
      </p>
    </div>
  </div>

  <!-- Status Filter -->
  <div class="acs-filter-section">
    <div class="acs-filter-group">
      <label for="status-select">Filter by Status:</label>
      <select 
        id="status-select"
        class="form-select"
        [(ngModel)]="selectedStatus"
        (ngModelChange)="onStatusFilterChange()">
        <option *ngFor="let status of statusOptions" [value]="status.value">
          {{ status.label }}
        </option>
      </select>
    </div>
  </div>

  <!-- Data Grid -->
  <div class="acs-grid-section">
    <div class="acs-grid-section__container">
      <acs-data-grid
        [data]="filteredAnnouncements"
        [columns]="columns"
        [loading]="loading"
        [searchable]="true"
        [sortable]="true"
        [enableDropdownFilters]="true"
        [showPagination]="true"
        [pageSize]="20"
        searchPlaceholder="Search announcements..."
        emptyMessage="No announcements found. Create your first announcement to get started.">
      </acs-data-grid>
    </div>
  </div>


  <!-- View Announcement Modal -->
  <acs-modal
    [isOpen]="showViewModal"
    title="View Announcement"
    size="large"
    (closed)="closeViewModal()">
    <div class="announcement-view-modal" *ngIf="selectedAnnouncement">
      <!-- Priority Badge and Title -->
      <div class="announcement-view-modal__header">
        <span class="announcement-view-modal__priority">
          {{ getPriorityIcon(selectedAnnouncement.Priority) }} {{ selectedAnnouncement.Priority | uppercase }}
        </span>
        <h2 class="announcement-view-modal__title">{{ selectedAnnouncement.Title }}</h2>
      </div>

      <!-- Metadata -->
      <div class="announcement-view-modal__metadata">
        <div class="announcement-view-modal__metadata-item">
          <strong>Status:</strong> 
          <span [class]="getStatusClass(selectedAnnouncement.Status)">
            {{ selectedAnnouncement.Status | uppercase }}
          </span>
        </div>
        <div class="announcement-view-modal__metadata-item">
          <strong>Published:</strong> {{ formatDate(selectedAnnouncement.PublishDate) }}
        </div>
        <div class="announcement-view-modal__metadata-item" *ngIf="selectedAnnouncement.ExpiryDate">
          <strong>Expires:</strong> {{ formatDate(selectedAnnouncement.ExpiryDate) }}
        </div>
        <div class="announcement-view-modal__metadata-item">
          <strong>Requires Acknowledgment:</strong> 
          {{ selectedAnnouncement.RequiresAcknowledgment ? 'Yes' : 'No' }}
        </div>
      </div>

      <!-- Content -->
      <div class="announcement-view-modal__content" [innerHTML]="selectedAnnouncement.Content"></div>

      <!-- Actions -->
      <div class="announcement-view-modal__actions">
        <acs-button 
          variant="secondary" 
          (clicked)="closeViewModal()">
          Close
        </acs-button>
        <acs-button 
          variant="danger" 
          *ngIf="canDelete(selectedAnnouncement)"
          (clicked)="deleteAnnouncement({announcement: selectedAnnouncement, totalTargets: 0, readCount: 0, unreadCount: 0, acknowledgedCount: 0, dismissedCount: 0}); closeViewModal()">
          <span slot="icon">🗑️</span>
          Delete
        </acs-button>
      </div>
    </div>
  </acs-modal>

  <!-- Analytics Modal -->
  <acs-modal
    [isOpen]="showAnalyticsModal"
    title="📊 Announcement Analytics"
    size="large"
    (closed)="closeAnalyticsModal()">
    <div class="announcement-analytics-modal" *ngIf="selectedAnnouncement">
      <!-- Announcement Title -->
      <div class="announcement-analytics-modal__header">
        <h3>{{ selectedAnnouncement.Title }}</h3>
        <span class="announcement-analytics-modal__status">
          {{ getStatusBadge(selectedAnnouncement.Status) }}
        </span>
      </div>

      <!-- Key Metrics -->
      <div class="announcement-analytics-modal__metrics">
        <div class="metric-card">
          <div class="metric-card__value">{{ getAnnouncementStats(selectedAnnouncement.ID).totalTargets }}</div>
          <div class="metric-card__label">Total Recipients</div>
        </div>
        <div class="metric-card">
          <div class="metric-card__value">{{ getAnnouncementStats(selectedAnnouncement.ID).readCount }}</div>
          <div class="metric-card__label">Read</div>
        </div>
        <div class="metric-card">
          <div class="metric-card__value">{{ getAnnouncementStats(selectedAnnouncement.ID).unreadCount }}</div>
          <div class="metric-card__label">Unread</div>
        </div>
        <div class="metric-card">
          <div class="metric-card__value">{{ getEngagementRate(getAnnouncementStats(selectedAnnouncement.ID)) }}</div>
          <div class="metric-card__label">Engagement Rate</div>
        </div>
      </div>

      <!-- Detailed Stats -->
      <div class="announcement-analytics-modal__details">
        <h4>Detailed Statistics</h4>
        <div class="stats-grid">
          <div class="stat-item">
            <span class="stat-label">Acknowledged:</span>
            <span class="stat-value">{{ getAnnouncementStats(selectedAnnouncement.ID).acknowledgedCount }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Dismissed:</span>
            <span class="stat-value">{{ getAnnouncementStats(selectedAnnouncement.ID).dismissedCount }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">Published Date:</span>
            <span class="stat-value">{{ formatDate(selectedAnnouncement.PublishDate) }}</span>
          </div>
          <div class="stat-item" *ngIf="selectedAnnouncement.ExpiryDate">
            <span class="stat-label">Expiry Date:</span>
            <span class="stat-value">{{ formatDate(selectedAnnouncement.ExpiryDate) }}</span>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="announcement-analytics-modal__actions">
        <acs-button 
          variant="secondary" 
          (clicked)="closeAnalyticsModal()">
          Close
        </acs-button>
        <acs-button 
          variant="primary" 
          (clicked)="exportAnalytics()">
          <span slot="icon">📥</span>
          Export Data
        </acs-button>
      </div>
    </div>
  </acs-modal>
</div>